import { useNavigate } from "react-router-dom";
import styles from "./Programs.module.css";
import Header from '../.shared/header/header';
import Footer from '../.shared/footer/footer';
import ProductCard from "../.shared/ProductCard/ProductCard";
import Pricing from "../../data/Pricing";

export default function Programs() {
    const navigate = useNavigate();

    let previousDosageForm = null;
    let previousFrequency = null;
    let previousProductName = null;

    // If price_id is in local storage, use it to set default params for corresponding product card
    const planId = localStorage.getItem('plan_id');
    if (planId) {
        const pricing = Pricing();
        const pricingDetails = pricing.getPlanById(planId);
        if (pricingDetails && pricingDetails.product) {
            previousDosageForm = pricingDetails.formulation || 'injectable';
            previousFrequency = pricingDetails.subscription_length === '3 Months' ? 'threeMonths' : 'monthly';
            previousProductName = pricingDetails.product;
        }
    }

    return (
    <>
        <div className={styles.programsPageContainer}>

            <Header />

            <div className={styles.productsDisplay}>

                <span className={styles.pageTitle}>Clinician-guided weight-management options tailored to your individual health needs</span>

                <div className={styles.display}>
                    <ProductCard medication={'Semaglutide'} defaultFrequency={previousProductName === 'Semaglutide' ? previousFrequency : 'monthly'} defaultDosageForm={previousProductName === 'Semaglutide' ? previousDosageForm : 'injectable'} />
                    <ProductCard medication={'Tirzepatide'} defaultFrequency={previousProductName === 'Tirzepatide' ? previousFrequency : 'monthly'} defaultDosageForm={previousProductName === 'Tirzepatide' ? previousDosageForm : 'injectable'} />
                </div>

                <div className={styles.resultAdditionalInfo}>
                    <span className={styles.resultInfo}>*Medication options offered through the program are available only following evaluation and determination by independent licensed clinicians, who exercise independent medical judgment based on each patient's individual health profile. Treatment types and eligibility are determined solely by the clinician as part of a personalized treatment plan. If prescribed, all medications are fulfilled and dispensed exclusively by licensed third-party pharmacies operating in compliance with all applicable state and federal laws and regulatory requirements. We do not manufacture, dispense, distribute, or sell medications.</span>
                </div>

            </div>

            <div className={styles.programsInfo}>

                <div className={styles.programsInfoContainer}>

                    <span className={styles.programsInfoTitle}>Program Requirements</span>

                    <span className={styles.programsInfoSubtitle}>BMI Qualifications</span>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Standard Program: BMI of 27 or greater for full dose options</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Modified Program: BMI 25-27 with limited dose options available</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Maintenance: Low-dose maintenance available when BMI reaches 24</span>
                    </div>

                    <span className={styles.programsInfoSubtitle}>Medical Screening</span>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Comprehensive medical history review by licensed clinician</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Evaluation of current medications and health conditions</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Assessment of contraindications and safety factors</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Determination of appropriate medication and dosing plan</span>
                    </div>

                </div>

                <div className={styles.programsInfoContainer}>

                    <span className={styles.programsInfoTitle}>All Programs include</span>

                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Consultation with a licensed, independent healthcare provider (when required)</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Independent clinical evaluation and prescribing by licensed healthcare providers, when appropriate</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Prescriptions fulfilled by licensed third-party pharmacies</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Dedicated Patient Care Coordinator</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Program includes access to prescribed treatment as determined appropriate by your licensed healthcare provider</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Ongoing support and coordination through the platform; clinical access may vary based on provider availability and applicable regulations</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Monthly check-ins and follow-ups</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Medications, if prescribed, are shipped directly to you by licensed pharmacies</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Plans renew automatically</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Money back guarantee if you do not medically qualify</span>
                    </div>

                </div>

            </div>

            <div className={styles.FAQSection}>
                <div className={styles.FAQContainer}>
                    <span className={styles.FAQTitle}>Have questions about our programs?</span>
                    <button className={styles.FAQButton} onClick={() => navigate('/knowledge-center')}>Visit our FAQ Section</button>
                    <span className={styles.FAQDescription}>for detailed answers about GLP-1 medications, dosage, side effects, and more.</span>
                </div>
            </div>

            <div className={styles.additionalInfoSection}>
                <span className={styles.additionalInfoText}>If you proceed with enrollment, your information will be reviewed by a licensed, independent 
                    healthcare provider who exercises independent medical judgment to determine treatment eligibility and next steps. If you are found 
                    ineligible for a prescription after clinical assessment, you will receive a full refund.</span>
                <span className={styles.additionalInfoText}>Our telehealth-enabled platform provides non-clinical services and care coordination, while 
                    clinical care is delivered by licensed, independent healthcare providers through a third‑party provider network. Programs are 
                    subscription-based with monthly or quarterly recurring payments. Monthly plans renew every 28 days, and 3-month plans renew every 72 days, and may include a consultation with a clinician licensed in your state, 
                    depending on applicable regulations. Consultations may occur via phone or video and are supported by a Patient Care Coordinator who 
                    can assist with general questions and coordination.</span>
                <span className={styles.additionalInfoText}>If clinically appropriate, a licensed healthcare provider may prescribe treatment based on 
                    the information gathered during your evaluation. Prescription fulfillment is coordinated through independent, licensed pharmacies 
                    within the third‑party provider network. For medical guidance, including questions about medication use or side effects, you should 
                    consult your prescribing provider or pharmacist. Dosing and treatment decisions are determined solely by your healthcare provider 
                    based on your medical history, treatment response, and ongoing evaluation, including consideration of prior GLP‑1 use.</span>
                <span className={styles.additionalInfoText}>Monthly check-ins and follow-ups are included. You may cancel at any time.</span>
            </div>

        </div>
        <Footer />
    </>
    )
}